"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameValid = void 0;
const nameValid = (name) => {
    var _a;
    if (typeof name === 'string') {
        const getLetters = (_a = name.replace(/\s/g, '').match(/\D/gi)) === null || _a === void 0 ? void 0 : _a.join('');
        if (getLetters) {
            return getLetters.length >= 2 && getLetters.length <= 100;
        }
        return false;
    }
    return false;
};
exports.nameValid = nameValid;
